// Affiche la photo si "src" est renseigné ; sinon rien n'est affiché.
export const PhotoPlaceholder = ({ src, alt = "", className = "", testId }) => {
  if (!src) return null;
  return (
    <div className={`relative overflow-hidden ${className}`} data-testid={testId}>
      <img src={src} alt={alt} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
    </div>
  );
};
